import { render } from "./XTagGroup.vue?vue&type=template&id=2d236e8e&scoped=true"
import script from "./XTagGroup.vue?vue&type=script&lang=js"
export * from "./XTagGroup.vue?vue&type=script&lang=js"

import "./XTagGroup.vue?vue&type=style&index=0&id=2d236e8e&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d236e8e"]])

export default __exports__